(() => {
  const slugify = (text) =>
    text
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const createLink = (heading) => {
    const li = document.createElement('li');
    li.className = 'article-toc__item';

    const link = document.createElement('a');
    link.className = 'article-toc__link reversed-link';
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', (event) => {
      event.preventDefault();
      heading.focus({ preventScroll: true });
      heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.replaceState(null, '', `#${heading.id}`);
    });

    li.appendChild(link);
    return li;
  };

  const assignHeadingIds = (headings) => {
    const usedIds = new Set();

    headings.forEach((heading, index) => {
      let baseId = slugify(heading.textContent);

      if (!baseId) {
        baseId = `section-${index + 1}`;
      }

      let uniqueId = baseId;
      let suffix = 2;

      while (usedIds.has(uniqueId)) {
        uniqueId = `${baseId}-${suffix}`;
        suffix += 1;
      }

      usedIds.add(uniqueId);
      heading.id = uniqueId;

      if (!heading.hasAttribute('tabindex')) {
        heading.setAttribute('tabindex', '-1');
      }
    });
  };

  const buildFlatList = (headings) => {
    const list = document.createElement('ol');
    list.className = 'article-toc__list';

    headings.forEach((heading) => {
      list.appendChild(createLink(heading));
    });

    return list;
  };

  const buildNestedList = (headings) => {
    const list = document.createElement('ol');
    list.className = 'article-toc__list';

    let currentSectionList = null;

    headings.forEach((heading) => {
      if (heading.tagName === 'H2') {
        const item = createLink(heading);
        currentSectionList = document.createElement('ol');
        currentSectionList.className = 'article-toc__list article-toc__list--nested';
        item.appendChild(currentSectionList);
        list.appendChild(item);
        return;
      }

      if (heading.tagName === 'H3') {
        const item = createLink(heading);
        item.classList.add('article-toc__item--child');

        if (currentSectionList) {
          currentSectionList.appendChild(item);
        } else {
          list.appendChild(item);
        }
      }
    });

    return list;
  };

  const buildNav = (headings, config) => {
    const nav = document.createElement('nav');
    nav.className = 'article-toc blocks-radius';
    nav.setAttribute('aria-label', config.title);

    const title = document.createElement('p');
    title.className = 'article-toc__title h5 m-0';
    title.textContent = config.title;
    nav.appendChild(title);

    const list = config.nested ? buildNestedList(headings) : buildFlatList(headings);
    nav.appendChild(list);

    return nav;
  };

  const initArticleToc = (configElement) => {
    let config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      return;
    }

    const content = document.getElementById(config.contentId);

    if (!content) {
      return;
    }

    const selector = config.nested ? 'h2, h3' : 'h2';
    const headings = [...content.querySelectorAll(selector)].filter((heading) => heading.textContent.trim() !== '');

    if (headings.length < config.minHeadings) {
      return;
    }

    assignHeadingIds(headings);

    const nav = buildNav(headings, config);
    content.insertBefore(nav, headings[0]);
  };

  document.querySelectorAll('[data-article-toc-config]').forEach(initArticleToc);
})();
